import React from 'react';

const LabelPromotor = ({ Promotor, guardarCampoCuenta }) => {

    const lblPromotor = <label className="label-secondary">{Promotor}</label>;

    return (
    <div className="row">
        <div className="col-xs-12">
            {lblPromotor} | <a onClick={() => guardarCampoCuenta(undefined, "PromotorId")} >Cambiar</a>
        </div>
    </div>
    );
}

export default LabelPromotor;